















import LoginScreen1 from 'components/LoginScreen1.vue'
import LoginScreen3 from 'components/LoginScreen2.vue'
import { getProfiles } from 'src/helpers/profiles'
import { Component, Vue } from 'vue-property-decorator'
import { LoginProfile } from '../types'

const BgAnimation = () => import('components/BgAnimation.vue')

@Component({
  components: {
    BgAnimation,
    LoginScreen3,
    LoginScreen1
  }
})
export default class Login extends Vue {
  public profiles: LoginProfile[] = []

  public loginAs: LoginProfile | null = null

  public errors: Record<string, string[]> = {}

  public loading: boolean = false

  get animationDerection () {
    return this.loginAs ? 'right' : 'left'
  }

  get enterTransitionClass () {
    return this.animationDerection === 'right' ? 'animated bounceInRight' : 'animated bounceInLeft'
  }

  get leaveTransitionClass () {
    return this.animationDerection === 'right' ? 'animated bounceOutLeft' : 'animated bounceOutRight'
  }

  meta () {
    return {
      title: `${this.$t(this.$msg.LoginTitle)}${this.$appConfig.titlePostfix}`
    }
  }

  created () {
    getProfiles(this.$store.state.auth.fp, (profiles) => {
      this.profiles = profiles
    })
  }

  setUser (user: LoginProfile) {
    this.loginAs = user
  }
}
